import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const customer_callback_migration = ({ event: { kind, data: { original_name } } }) =>
  <div className={kind}>
    {original_name} was updated to Customer Callback for this phase.
  </div>;

customer_callback_migration.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      flag_id: PropTypes.number,
      original_name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};




// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/customer_callback_migration.jsx